import { useEffect, useState } from 'react';
import { useUserContext } from '../context/UserContext';
import HttpClient from '../Api/HttpClient';

export function usePendo() {
  const { user } = useUserContext();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized && window.pendo) {
      window.pendo.initialize({
        visitor: {
          id: user.id,
          email: user.email,
          full_name: `${user.first_name} ${user?.last_name}`,
          role: user.role,
        },
        account: { id: HttpClient.tenant() },
      });
      setInitialized(true);
    }
  }, [initialized]);
}
